import type { EarthlyBranch } from '../types/branches';
import type { Relation } from '../types/relations';
import type { PillarPosition } from '../types/pillars';
import { branchIndex } from '../core/sexagenary';

// 파 pairs:
// 子酉, 丑辰, 寅亥, 卯午, 巳申, 未戌
export const DESTROY_PAIRS: [number, number][] = [
  [0, 9],  // 子酉
  [1, 4],  // 丑辰
  [2, 11], // 寅亥
  [3, 6],  // 卯午
  [5, 8],  // 巳申
  [7, 10], // 未戌
];

export function findEarthlyDestroys(
  branches: { branch: EarthlyBranch; position: PillarPosition }[]
): Relation[] {
  const relations: Relation[] = [];

  for (let i = 0; i < branches.length; i++) {
    for (let j = i + 1; j < branches.length; j++) {
      const a = branchIndex(branches[i].branch);
      const b = branchIndex(branches[j].branch);

      for (const [s1, s2] of DESTROY_PAIRS) {
        if ((a === s1 && b === s2) || (a === s2 && b === s1)) {
          const [first, second] = a === s1 ? [branches[i], branches[j]] : [branches[j], branches[i]];
          relations.push({
            type: '파',
            pillars: [branches[i].position, branches[j].position],
            branches: [first.branch, second.branch],
            description: `${first.branch}${second.branch}파`,
          });
        }
      }
    }
  }

  return relations;
}
